import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI.js'
import SearchUI from '../../../widgets/input/SearchUI.js'
import VendorCreateModalSF from '../vendor/VendorCreateModalSF.js'
import VendorPanCreateModalSF from '../vendor/VendorPanCreateModalSF.js'
import CardUI from '../../../widgets/layout/CardUI.js'

const VendorsPageUI = ({ context, account, vendorList, onSearchFilterChange, searchFilter,
  onRefreshClick, onSubmit, onCancelClick, onCancelPanClick, createMode, panCreateMode,
  onVendorCreateClick, onVendorPanCreateClick 
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_cal' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!vendorList}
    account={account} page='vendors'
  >
    {
      (!vendorList) &&
      <SpinnerComponentUI />
    }
    {
      vendorList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <IconButtonUI icon='icon-plus' label='Create without PAN' onClick={onVendorCreateClick} />
              <IconButtonUI icon='icon-user-plus' label='Create with PAN' onClick={onVendorPanCreateClick} />
              <span className='g_m_left_100 g_large'><b>Vendors</b></span>
            </div>
          }
          right={
            <div className='g_flex_h'>
              <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
            </div>}
        />
        <CardUI>
          <table className='g_full_width'>
            <thead>
              <tr>
                <th className='g_p_right_100'>Vendor Name</th>
                <th className='g_p_left_100'>PAN</th>
                <th className='g_p_left_100'>Bank Details</th>
                <th className='g_p_left_100'>Contact</th>
                <th className='g_p_left_100'>TDS Nature</th>
                <th className='g_p_left_100'>GSTIN</th>
              </tr>
            </thead>
            <tbody>
              {vendorList.map((vendor, index) => (
                <VendorRowUI key={index} context={context} vendor={vendor} />
              ))}
            </tbody>
          </table>
        </CardUI>
      </div>
    }
    <VendorCreateModalSF
      createMode={createMode}
      account={account}
      context={context}
      onCancelClick={onCancelClick}
      onSubmit={onSubmit}
      onRefreshClick={onRefreshClick}
    />
    <VendorPanCreateModalSF
      createMode={panCreateMode}
      account={account}
      context={context}
      onCancelClick={onCancelPanClick}
      onSubmit={onSubmit}
      onRefreshClick={onRefreshClick}
    />

  </SuperUserAccountPageUI>

const VendorRowUI = ({ context, vendor }) =>
  <tr>
    <td className='g_p_right_100'>
      {vendor.vendorName}
      <br />
      <span className='g_muted g_m_top_5'>{vendor.vendorId}</span>
      <br />
      <span>{vendor.bankAccountValidation}</span>
    </td>
    <td className='g_p_left_100'>
      {vendor.panNumber}
    </td>
    <td className='g_p_left_100'>
      <div className='g_m_bottom_5'>Acc #: {vendor.bankAccountNumber}</div>
      <div className='g_m_bottom_5'>IFSC: {vendor.bankIFSCCode}</div>
      <div>Beneficiary: {vendor.bankBeneficiaryName}</div>
    </td>
    <td className='g_p_left_100'>
      {vendor.contactFirstName} {vendor.contactLastName}
      <br />
      Ph: {vendor.contactPhone}
      <br />
      Email: {vendor.contactEmail}
    </td>
    <td className='g_p_left_100'>
      {vendor.tdsNature}
    </td>
    <td className='g_p_left_100'>
      {vendor.gstin}
    </td>
  </tr>




export default VendorsPageUI
